// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clear-date[data-v-3466af35]{position:absolute;top:2px;right:2px}", ""]);
// Exports
module.exports = exports;
